import { useEffect } from 'react';
import { useFetchDashboardData } from '../use-fetch-dashboard';
import { useQrStats } from './charts/use-qr-stats';
import { useDashboardQrCards } from './use-dashboard-qr-cards';
import { useQueryParams } from '../../../../../hooks/use-query-params';
import { useScansStore } from '../../../../../store/use-scans-store';
import { formatDateTimeRangeFromString } from '../../../../../helpers/date-time';
import { useLang } from '../../../../../hooks/use-lang';

export const useDashboardQr = () => {
  useFetchDashboardData(['qr_stats']);

  const params = useQueryParams().getQueryParams();
  const { page, pageSize, branch, range } = params;
  const { getLocale } = useLang();

  const { fetchScans, isLoading, pagination, scans } = useScansStore();

  useEffect(() => {
    const { from, to } = range ? JSON.parse(params.range) : null;
    const formatted = formatDateTimeRangeFromString(JSON.stringify({ from, to }));

    fetchScans({
      is_by_company: true,
      page,
      page_size: pageSize,
      branch,
      from: formatted?.from,
      to: formatted?.to,
    });
  }, [page, pageSize, branch, range]);

  return {
    chartsData: [useQrStats()],
    cards: useDashboardQrCards(),
    isLoading,
    pagination,
    scans,
    getLocale,
  };
};
